var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "所属项目",
                  placeholder: "请选择项目",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm,
                            placeholder: "请选择项目",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmitSsxm("ssxm", {
                                    label: "projectName",
                                    value: "projectId",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssxm,
                                    "projectName"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssxm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssxm, "filterText", $$v)
                                },
                                expression: "ssxm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "projectName",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "qwjfrq",
                    expression: "'qwjfrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("qwjfrq"),
                  name: "qwjfrq",
                  label: "期望交付日期",
                  placeholder: "期望交付日期",
                  "input-align": "right",
                  rules: _vm.getRules("qwjfrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.qwjfrq,
                            placeholder: "请选择期望交付日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.qwjfrq, "qwjfrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "qwjfrq",
                          attrs: {
                            "min-date": _vm.minDate,
                            "show-confirm": false,
                            title: "选择期望交付日期",
                          },
                          on: { confirm: _vm.qwjfrqConfirm },
                          model: {
                            value: _vm.qwjfrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.qwjfrq, "show", $$v)
                            },
                            expression: "qwjfrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.qwjfrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "qwjfrq", $$v)
                  },
                  expression: "formData.qwjfrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "cglx",
                    expression: "'cglx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "cglx",
                  required: _vm.isRequired("cglx"),
                  value: _vm.formData.cglx,
                  label: "采购类型",
                  rules: _vm.getRules("cglx"),
                  placeholder: "请选择采购类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.cglx,
                            placeholder: "请选择采购类型",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.cglx, "cglx")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.cglx.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.cglx, "show", $$v)
                              },
                              expression: "cglx.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择采购类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.cglx.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("cglx")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.cglx)
                                },
                              },
                              model: {
                                value: _vm.cglx.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cglx, "filterText", $$v)
                                },
                                expression: "cglx.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "cglx",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.cglx.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.cglx.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sqsy",
                    expression: "'sqsy'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("sqsy"),
                  required: _vm.isRequired("sqsy"),
                  name: "sqsy",
                  rules: _vm.getRules("sqsy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "申请事由",
                  "show-word-limit": "",
                  placeholder: "请输入申请事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.sqsy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sqsy", $$v)
                  },
                  expression: "formData.sqsy",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
            [_vm._v("采购明细")]
          ),
          _vm._l(_vm.formData.cgmxb, function (item, index) {
            return _c(
              "van-cell-group",
              { key: index, staticClass: "b-r-10 m-t-20" },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      { attrs: { type: "flex", align: "center" } },
                      [
                        _c("van-col", { attrs: { span: 22 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`明细${index + 1}`))]
                          ),
                        ]),
                        _vm.isShowIcon("cgmxb")
                          ? _c(
                              "van-col",
                              {
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "cgmxb")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cgmxbMc",
                      expression: "'cgmxbMc'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("cgmxbMc"),
                    maxlength: "50",
                    name: "cgmxbMc",
                    rules: _vm.getRules("cgmxbMc"),
                    required: _vm.isRequired("cgmxbMc"),
                    label: "名称",
                    placeholder: "请输入名称",
                    "input-align": "right",
                  },
                  model: {
                    value: item.cgmxbMc,
                    callback: function ($$v) {
                      _vm.$set(item, "cgmxbMc", $$v)
                    },
                    expression: "item.cgmxbMc",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cgmxbGg",
                      expression: "'cgmxbGg'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("cgmxbGg"),
                    maxlength: "50",
                    name: "cgmxbGg",
                    rules: _vm.getRules("cgmxbGg"),
                    required: _vm.isRequired("cgmxbGg"),
                    label: "规格",
                    placeholder: "请输入规格",
                    "input-align": "right",
                  },
                  model: {
                    value: item.cgmxbGg,
                    callback: function ($$v) {
                      _vm.$set(item, "cgmxbGg", $$v)
                    },
                    expression: "item.cgmxbGg",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cgmxbSl",
                      expression: "'cgmxbSl'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("cgmxbSl"),
                    type: "number",
                    name: "cgmxbSl",
                    rules: _vm.getRules("cgmxbSl"),
                    required: _vm.isRequired("cgmxbSl"),
                    maxlength: 8,
                    placeholder: "请输入采购数量",
                    label: "采购数量",
                    "input-align": "right",
                  },
                  model: {
                    value: item.cgmxbSl,
                    callback: function ($$v) {
                      _vm.$set(item, "cgmxbSl", $$v)
                    },
                    expression: "item.cgmxbSl",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cgmxbDw",
                      expression: "'cgmxbDw'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("cgmxbDw"),
                    maxlength: "50",
                    name: "cgmxbDw",
                    rules: _vm.getRules("cgmxbDw"),
                    required: _vm.isRequired("cgmxbDw"),
                    label: "单位",
                    placeholder: "请输入单位",
                    "input-align": "right",
                  },
                  model: {
                    value: item.cgmxbDw,
                    callback: function ($$v) {
                      _vm.$set(item, "cgmxbDw", $$v)
                    },
                    expression: "item.cgmxbDw",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cgmxbJg",
                      expression: "'cgmxbJg'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("cgmxbJg"),
                    type: "number",
                    name: "cgmxbJg",
                    rules: _vm.getRules("cgmxbJg"),
                    required: _vm.isRequired("cgmxbJg"),
                    maxlength: 8,
                    placeholder: "请输入采购金额",
                    label: "采购金额",
                    "input-align": "right",
                  },
                  model: {
                    value: item.cgmxbJg,
                    callback: function ($$v) {
                      _vm.$set(item, "cgmxbJg", $$v)
                    },
                    expression: "item.cgmxbJg",
                  },
                }),
              ],
              1
            )
          }),
          !_vm.isDisabled("cgmxb")
            ? _c(
                "van-row",
                [
                  _c("van-col", { attrs: { span: 12 } }),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "添加采购明细",
                        },
                        on: { click: _vm.addCgItem },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "van-cell-group",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "zjg",
                  expression: "'zjg'",
                },
              ],
              staticClass: "m-t-20",
            },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "zjg",
                    expression: "'zjg'",
                  },
                ],
                attrs: {
                  center: "",
                  rules: _vm.getRules("zjg"),
                  required: _vm.isRequired("zjg"),
                  label: "采购总金额",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.zjg && _vm.formData.zjg != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.zjg) + " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.zjg && _vm.formData.zjg != 0
                            ? _c("div", [
                                _c("span", { staticClass: "p-l-20" }, [
                                  _vm._v(" 大写："),
                                ]),
                                _c("span", { staticClass: "cor-F64646" }, [
                                  _vm._v(
                                    _vm._s(_vm.getChinese(_vm.formData.zjg))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.zjg,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "zjg", $$v)
                  },
                  expression: "formData.zjg",
                },
              }),
            ],
            1
          ),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "zffs",
                    expression: "'zffs'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "zffs",
                  required: _vm.isRequired("zffs"),
                  value: _vm.formData.zffs,
                  label: "支付方式",
                  rules: _vm.getRules("zffs"),
                  placeholder: "请选择支付方式",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.zffs,
                            placeholder: "请选择支付方式",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.zffs, "zffs")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.zffs.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.zffs, "show", $$v)
                              },
                              expression: "zffs.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择支付方式",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.zffs.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("zffs")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.zffs)
                                },
                              },
                              model: {
                                value: _vm.zffs.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.zffs, "filterText", $$v)
                                },
                                expression: "zffs.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "zffs",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.zffs.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.zffs.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bz",
                    expression: "'bz'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("bz"),
                  required: _vm.isRequired("bz"),
                  name: "bz",
                  rules: _vm.getRules("bz"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bz", $$v)
                  },
                  expression: "formData.bz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: { processData: _vm.processData, formData: _vm.formData },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }